import type { ReportExport, ReportKey, ReportSummary } from '@/api/types';

export type { ReportExport, ReportKey, ReportSummary };

/** The 5 Rapportages library cards, in the order the design-flowchart lists
 * them (PLAN-FASE3.md WP-04) — a code choice, not something the API
 * enumerates, same spirit as `src/features/documents/types.ts`'s
 * `CATEGORIES`/`AUDIENCES`. */
export const REPORT_KEYS: ReportKey[] = [
  'vitaliteitstrends',
  'deelnamerapport',
  'challenge-resultaten',
  'communicatiebereik',
  'documentgebruik',
];
